import { useEffect, useState } from "react";
import { businessToday, subscribeBusinessClock } from "../util/businessClock";

/**
 * Business "today" (YYYY-MM-DD) that updates once the server clock is known,
 * so anything computed before /server/clock answered (browser date) is redone.
 */
export const useBusinessToday = (): string => {
	const [today, setToday] = useState(businessToday);
	useEffect(() => {
		setToday(businessToday());
		return subscribeBusinessClock(() => setToday(businessToday()));
	}, []);
	return today;
};
